import styled from 'styled-components';

export const ValueContainer = styled.div`
  padding: 6px 8px;
  width: 100%;
  height: 100%;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;

  &:hover {
    .cell-comment-container {
      visibility: visible;
    }
  }

  .text {
    width: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 12px;
    p {
      white-space: normal;
      line-height: 1.5;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  p.error-message {
    color: #ff6b6b;
    font-size: 12px;
    white-space: initial;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  min-height: 40px;
  padding: 6px 8px;
  box-sizing: border-box;
  font-size: 12px !important;
  line-height: 17px !important;
  &:disabled {
    color: #909296 !important;
  }
`;
